<template>
  <b-modal
    id="the-plan-selection-modal"
    :active.sync="showModal"
    full-screen
  >
    <div
      id="pricing"
      class="modal-card pricing-page"
      style="width: auto;"
    >
      <header
        class="modal-card-head is-block "
        style="padding: 28px 32px 8px 32px;"
      >
        <onboarding-wizard-header active-step="plan" />
        <span class="icon-static xl large-cart margin-bottom-lg" />
        <h3 class="title is-3">
          {{ modalTitle }}
        </h3>
      </header>
      <section class="modal-card-body">
        <div class="container">
          <div
            class="columns mb-6"
          >
            <div class="column" />
            <div class="column is-9-tablet is-11-desktop is-9-widescreen">
              <div class="mb-4">
                <p
                  v-if="trialMode"
                  class="text xl"
                >
                  Start a free trial today to get unlimited access to thousands of tracks &amp; SFX from Sonata
                  artists. You can cancel anytime during the trial without being charged anything.
                </p>
                <p
                  v-else
                  class="text xl"
                >
                  Subscribe today to get unlimited access to thousands of tracks &amp; SFX from Sonata artists.
                </p>
              </div>

              <div>
                <b-switch
                  v-model="showYearly"
                  class="ml-0 is-left-right is-accent"
                  type="is-danger"
                >
                  {{ intervalSwitchText }}
                </b-switch>
              </div>
              <div class="is-clearfix" />

              <div
                id="table"
                class="columns mt-5 mb-5 ml-1"
              >
                <div class="column">
                  <pricing-plan-card-list
                    class="text"
                    :plans="sortedPlans"
                    compact
                  />
                </div>
              </div>

              <p>
                See full plan details
                and FAQs on our
                <router-link
                  :to="{ name: 'pricing' }"
                  target="_blank"
                >pricing page</router-link>.
              </p>
            </div>
            <div class="column" />
          </div>
        </div>
      </section>
    </div>
  </b-modal>
</template>

<script>
import OnboardingWizardHeader from '@/components/OnboardingWizardHeader.vue'
import PricingPlanCardList from '@/components/PricingPlanCardList.vue'

export default {
  name: 'ThePricingModal',

  components: {
    PricingPlanCardList,
    OnboardingWizardHeader
  },

  data () {
    return {
      showYearly: false
    }
  },

  computed: {
    showModal: {
      get: function () {
        return this.$store.getters['subscriptions/showPlanSelectionModal']
      },
      set: function (newValue) {
        if (newValue === true) {
          this.$store.dispatch('subscriptions/showPlanSelectionModal')
        } else {
          this.$store.dispatch('subscriptions/hidePlanSelectionModal')
        }
      }
    },

    isLoggedIn: function () {
      return this.$store.getters['auth/isLoggedIn']
    },

    sortedPlansMonthly: function () {
      const plans = [...this.$store.getters['subscriptions/plans']].filter((plan) => plan.interval === 'month')
      return plans.sort((a, b) => a.amount - b.amount)
    },

    sortedPlansYearly: function () {
      const plans = [...this.$store.getters['subscriptions/plans']].filter((plan) => plan.interval === 'year')
      return plans.sort((a, b) => a.amount - b.amount)
    },

    sortedPlans: function () {
      if (this.showYearly) {
        return this.sortedPlansYearly
      } else {
        return this.sortedPlansMonthly
      }
    },

    currencySymbol: function () {
      // WARNING: Assuming that all products have the same currency.
      if (this.$store.getters['cart/products'].length > 0) {
        return this.$store.getters['cart/products'][0].currency.symbol
      }
      return ''
    },

    trialMode: function () {
      return this.$store.getters['subscriptions/createSubscriptionWithTrial']
    },

    modalTitle: function () {
      if (this.trialMode) {
        return 'Enjoying Sonata? Start a free trial'
      }
      return 'Choose your plan'
    },

    selectButtonText: function () {
      if (this.trialMode) {
        return 'Start free trial'
      }
      return 'Select'
    },

    intervalSwitchText: function () {
      if (this.showYearly) {
        return 'Show monthly'
      } else {
        return 'Get two months free when paid yearly'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/_variables.scss";

.steps-container {
  padding-bottom: 1em;
}
.steps-item {
  padding-right: 1em;
}
.steps-item span {
  color: $grey-light;
}
.steps-item.active span {
  color: $grey-dark;
}
</style>
